// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"274":"beta-terms","296":"privacy","929":"terms"}[chunkId] + "." + {"274":"69c9852e","296":"febd7707","929":"986e703b"}[chunkId] + ".css";
};